import React from 'react';
import Helmet from 'react-helmet';
import PageLayout from '../../components/PageLayout';
import styles from './program.module.scss';
import Session from './Session/Session';
import moment from 'moment';
import cnames from 'classnames'

class Program extends React.Component {
  constructor(props) {
    super(props);

    this.sessions = this.getSessions();
    this.days = this.getDays();
    this.state = { day: this.days[0].name.long, time: this.days[0].times[0] }
  }

  getSessions() {
    return this.props.data.allMarkdownRemark.edges.map(edge => edge.node);
  }

  getDays() {
    const baseArray = [
      { name: { long: 'Thursday', short: 'Thur', date: '9th April' } },
      { name: { long: 'Friday', short: 'Fri', date: '10th April' } },
      { name: { long: 'Saturday', short: 'Sat', date: '11th April' } },
      { name: { long: 'Sunday', short: 'Sun', date: '12th April' } },
    ];

    const unique = (val, i, self) => self.indexOf(val) === i;

    const parseTime = t => moment(t, 'h:mma');
    return baseArray
      .map(day => ({
        ...day,
        times: this.sessions
          .filter(s => s.frontmatter.day === day.name.long)
          .map(session => session.frontmatter.time)
          .filter(unique)
          .sort((a, b) => {
            const ma = parseTime(a);
            const mb = parseTime(b);
            return ma<mb?-1:ma>mb?1:0;
          })
      }));
  }

  get isMobile() {
    return (typeof window !== 'undefined' && window.innerWidth < 400);
  }

  renderNav() {
    return (
      <div className={styles.nav}>
        <ol className={styles.dayNav}>
          {this.days.map(day => (
            <li key={day.name.long}>
              <a href={`#${day.name.long}`}>
                {/* {this.isMobile ? day.name.short : day.name.long} */}
                {day.name.long}
              </a>
            </li>
          ))}
        </ol>
      </div>
    );
  }

  render() {
    return (
      <PageLayout location={this.props.location}>
        <Helmet>
          <title>Program</title>
          <meta property="og:title" content="Conference Program for Marxism 2020" />
          <meta property="og:description" content="Check out the new conference program for 2020." />
        </Helmet>
      <div className={styles.wrapper}>

        { this.renderNav() }

        <div className={styles.sessions}>
          { this.days.map(day => (
            <div key={day.name.long}>
              <div className={styles.anchor} id={day.name.long} />
              <h2 className={styles.dayTitle}>{day.name.long} {day.name.date}</h2>
              { day.times.map(time => (
                <React.Fragment>
                  <h3 className={styles.slotTitle}>{day.name.long} {time}</h3>
                  <div className={styles.timeslot}>
                    { this.sessions
                        .filter(s => s.frontmatter.day === day.name.long && s.frontmatter.time === time)
                        .sort((a, b) => a.weight - b.weight)
                        .map(session => <Session
                          name={session.frontmatter.title}
                          stream={session.frontmatter.stream}
                          path={session.fields.path}
                          image={session.frontmatter.image}
                          key={session.title}
                          className={styles.session}
                        />)
                    }
                  </div>
                </React.Fragment>
              )) }
            </div>
          )) }
          </div>
        </div>
      </PageLayout>
    );
  }
}


class SimpleProgramList extends React.Component {
  constructor(props) {
    super(props);
    this.sessions = this.getSessions();
  }

  getSessions() {
    return this.props.data.allMarkdownRemark.edges.map(edge => edge.node);
  }

  render() {
    return (
      <PageLayout location={this.props.location}>
        <Helmet>
          <title>Program</title>
          <meta property="og:title" content="Conference Program for Marxism 2020" />
          <meta property="og:description" content="Check out the new conference program for 2020." />
        </Helmet>
      <div className={cnames(styles.wrapper, styles.simple)}>

        <div className={styles.sessions}>
          <div className={styles.timeslot}>
            { this.sessions
                .sort((a, b) => a.weight - b.weight)
                .map(session => <Session
                  name={session.frontmatter.title}
                  stream={session.frontmatter.stream}
                  path={session.fields.path}
                  image={session.frontmatter.image}
                  key={session.title}
                  className={styles.session}
                />)
            }
          </div>
        </div>
        </div>
      </PageLayout>
    );
  }
}

export default Program;

export const pageQuery = graphql`
  query GetAllSessions {
    allMarkdownRemark(filter: { frontmatter: { layout: { eq: "session"} }}) {
      edges {
        node {
          frontmatter {
            title,
            stream,
            day,
            time,
            weight,
            image,
          }
          fields {
            path
          }
        }
      }
    }
  }
`;
